import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5641981b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "license-container"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "desktop-license-table" }
const _hoisted_4 = { class: "header-filters" }
const _hoisted_5 = { class: "default-filters" }
const _hoisted_6 = { class: "header-filters-search" }
const _hoisted_7 = { class: "p-input-icon-left" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_9 = {
  key: 0,
  class: "selected-account-actions"
}
const _hoisted_10 = { class: "copy-actions" }
const _hoisted_11 = { class: "copy-actions" }
const _hoisted_12 = { class: "copy-actions" }
const _hoisted_13 = { class: "crud-actions" }
const _hoisted_14 = { class: "crud-actions" }
const _hoisted_15 = {
  key: 1,
  class: "admin-actions"
}
const _hoisted_16 = { class: "defaults" }
const _hoisted_17 = { class: "defaults" }
const _hoisted_18 = {
  key: 0,
  style: {"padding-top":"12px"}
}
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "lm-table-row-actions" }
const _hoisted_22 = {
  key: 0,
  class: "mobile-license-list"
}
const _hoisted_23 = { class: "mobile-license-controls" }
const _hoisted_24 = { class: "mobile-license-controls-actions" }
const _hoisted_25 = {
  key: 0,
  class: "mobile-license-empty"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { class: "mobile-license-card-header" }
const _hoisted_29 = { class: "mobile-license-badge" }
const _hoisted_30 = { class: "mobile-license-row" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Key:", -1))
const _hoisted_32 = { class: "mobile-license-row" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Domain:", -1))
const _hoisted_34 = { class: "mobile-license-row" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Activations:", -1))
const _hoisted_36 = { class: "mobile-license-row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Usage:", -1))
const _hoisted_38 = { class: "mobile-license-row" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created:", -1))
const _hoisted_40 = { class: "mobile-license-row" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Expiry:", -1))
const _hoisted_42 = { class: "mobile-license-actions" }
const _hoisted_43 = { key: 2 }
const _hoisted_44 = {
  key: 1,
  class: "license-container"
}
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "desktop-license-table" }
const _hoisted_47 = { class: "header-filters" }
const _hoisted_48 = {
  key: 0,
  class: "selected-account-actions"
}
const _hoisted_49 = { class: "copy-actions" }
const _hoisted_50 = { key: 0 }
const _hoisted_51 = { key: 1 }
const _hoisted_52 = {
  key: 0,
  class: "mobile-license-list"
}
const _hoisted_53 = { class: "mobile-license-controls" }
const _hoisted_54 = {
  key: 0,
  class: "mobile-license-empty"
}
const _hoisted_55 = { key: 0 }
const _hoisted_56 = { key: 1 }
const _hoisted_57 = { class: "mobile-license-card-header" }
const _hoisted_58 = { class: "mobile-license-badge" }
const _hoisted_59 = { class: "mobile-license-row" }
const _hoisted_60 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Key:", -1))
const _hoisted_61 = { class: "mobile-license-row" }
const _hoisted_62 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Domain:", -1))
const _hoisted_63 = { class: "mobile-license-row" }
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Activations:", -1))
const _hoisted_65 = { class: "mobile-license-row" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Usage:", -1))
const _hoisted_67 = { class: "mobile-license-row" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Created:", -1))
const _hoisted_69 = { class: "mobile-license-row" }
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Expiry:", -1))
const _hoisted_71 = { class: "mobile-license-actions" }
const _hoisted_72 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!
  const _component_CreateUpdateLicense = _resolveComponent("CreateUpdateLicense")!
  const _component_SendLicenseEmail = _resolveComponent("SendLicenseEmail")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.accountStore.isAdmin || _ctx.accountStore.isEmployee)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_DataTable, {
                  class: "license-datatable",
                  dataKey: "id",
                  scrollHeight: "flex",
                  stripedRows: "",
                  selectionMode: "single",
                  currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
                  paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                  rowsPerPageOptions: [10, 25, 50, 100],
                  selection: _ctx.selectedLicense,
                  "onUpdate:selection": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedLicense) = $event)),
                  stateKey: "license-table-state",
                  removableSort: "",
                  filterDisplay: "row",
                  scrollable: true,
                  rowClass: _ctx.rowClass,
                  value: _ctx.items,
                  paginator: true,
                  rows: _ctx.rows,
                  totalRecords: _ctx.totalRecords,
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters) = $event)),
                  loading: _ctx.loading,
                  globalFilterFields: _ctx.globalFilter,
                  onRowDblclick: _ctx.licenseDblClicked
                }, _createSlots({
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", null, [
                          _createVNode(_component_Dropdown, {
                            style: {"width":"12em"},
                            modelValue: _ctx.selectedAccount,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                            options: _ctx.selectableAccounts,
                            optionLabel: "name",
                            optionValue: "id",
                            filter: true,
                            showClear: true,
                            placeholder: "Select a Account",
                            onChange: _ctx.processFilterUpdate
                          }, null, 8, ["modelValue", "options", "onChange"])
                        ]),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("span", _hoisted_7, [
                            _hoisted_8,
                            _createVNode(_component_InputText, {
                              modelValue: _ctx.filters['global'].value,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                              placeholder: "Keyword Search"
                            }, null, 8, ["modelValue"])
                          ])
                        ])
                      ]),
                      (_ctx.selectedLicense && _ctx.selectedLicense.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_Button, {
                                disabled: !_ctx.selectedLicense.id,
                                label: "Send License Email",
                                onClick: _ctx.sendLicenseEmail,
                                class: "p-button-secondary p-button-outlined"
                              }, null, 8, ["disabled", "onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_11, [
                              _createVNode(_component_Button, {
                                disabled: !_ctx.selectedLicense.id,
                                label: "Copy Key",
                                onClick: _ctx.copyLicenseKey,
                                class: "p-button-secondary p-button-outlined"
                              }, null, 8, ["disabled", "onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_12, [
                              _createVNode(_component_Button, {
                                disabled: !_ctx.selectedLicense.id,
                                label: "Copy Hash",
                                onClick: _ctx.copyLicenseHash,
                                class: "p-button-secondary p-button-outlined"
                              }, null, 8, ["disabled", "onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                              _createVNode(_component_Button, {
                                disabled: !_ctx.selectedLicense.id,
                                label: "License Activations",
                                onClick: _ctx.licenseActivationsAction,
                                class: "p-button-secondary p-button-outlined"
                              }, null, 8, ["disabled", "onClick"])
                            ]),
                            _createElementVNode("div", _hoisted_14, [
                              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                                _createVNode(_component_Button, {
                                  label: "Delete License",
                                  disabled: _ctx.invalidLicenseFormToDelete,
                                  class: "p-button-danger p-button-outlined",
                                  onClick: _ctx.deleteLicense
                                }, null, 8, ["disabled", "onClick"]),
                                _createVNode(_component_ConfirmPopup)
                              ])), [
                                [_directive_tooltip, 'You can only delete one license at a time.']
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.selectedAccountDto.role != 'NewsletterRecipient')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createVNode(_component_Button, {
                                disabled: !_ctx.selectedAccount,
                                label: "Add",
                                class: "p-button-success p-button-outlined",
                                onClick: _ctx.createLicense
                              }, null, 8, ["disabled", "onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_Button, {
                          label: "Export",
                          class: "p-button-secondary p-button-outlined",
                          onClick: _ctx.exportLicenses
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    (_ctx.selectedAccountDto)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("h5", null, " Account: " + _toDisplayString(_ctx.selectedAccountDto.name) + " " + _toDisplayString(_ctx.selectedAccountDto.surname) + " " + _toDisplayString(_ctx.selectedAccountDto.company ? '(' + _ctx.selectedAccountDto.company + ')' : ''), 1)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  loading: _withCtx(() => [
                    _createTextVNode("Loading licenses. Please wait.")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      header: "Actions",
                      headerStyle: "padding-left: 18px;",
                      style: {"width":"10rem"},
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_21, [
                          _withDirectives((_openBlock(), _createElementBlock("div", null, [
                            _createVNode(_component_Button, {
                              type: "button",
                              icon: "pi pi-pencil",
                              onClick: ($event: any) => (_ctx.modifyLicenseFromGrid(data)),
                              class: "p-button-rounded p-button-outlined p-button-success"
                            }, null, 8, ["onClick"])
                          ])), [
                            [_directive_tooltip, 'Edit License']
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("div", null, [
                            _createVNode(_component_Button, {
                              type: "button",
                              icon: "pi pi-trash",
                              onClick: ($event: any) => (_ctx.deleteLicenseFromGrid(data, $event)),
                              class: "p-button-rounded p-button-outlined p-button-danger"
                            }, null, 8, ["onClick"])
                          ])), [
                            [_directive_tooltip, 'Delete License']
                          ]),
                          _withDirectives((_openBlock(), _createElementBlock("div", null, [
                            _createVNode(_component_Button, {
                              type: "button",
                              icon: "pi pi-file-export",
                              onClick: ($event: any) => (_ctx.exportLicense(data)),
                              class: "p-button-rounded p-button-outlined p-button-secondary"
                            }, null, 8, ["onClick"])
                          ])), [
                            [_directive_tooltip, 'Export License']
                          ])
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "product",
                      header: "Product",
                      style: {"width":"10rem"},
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.product), 1)
                      ]),
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_component_InputText, {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          onInput: ($event: any) => (filterCallback()),
                          placeholder: "Filter"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "key",
                      header: "Key",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.key), 1)
                      ]),
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_component_InputText, {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          onInput: ($event: any) => (filterCallback()),
                          placeholder: "Filter"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "type",
                      header: "Type",
                      style: {"width":"10rem"},
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.type), 1)
                      ]),
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_component_MultiSelect, {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          options: _ctx.licenseTypeOptions,
                          placeholder: "Any",
                          showClear: true,
                          maxSelectedLabels: 1,
                          onChange: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "activationsCount",
                      header: "Activations",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.activationsCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "maximumActivations",
                      header: "Max",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.maximumActivations), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "usage",
                      header: "Usage",
                      sortable: "",
                      "show-filter-menu": false,
                      style: {"min-width":"8rem"}
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode(_component_ProgressBar, {
                          value: (data.activationsCount / data.maximumActivations) * 100,
                          showValue: false
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "licenseDomain",
                      header: "Domain",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.licenseDomain), 1)
                      ]),
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_component_InputText, {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          onInput: ($event: any) => (filterCallback()),
                          placeholder: "Filter"
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "createdDate",
                      header: "Creation Date",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.createdDate.toDateString()), 1)
                      ]),
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_component_Calendar, {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          selectionMode: "range",
                          manualInput: false,
                          placeholder: "From – To",
                          showButtonBar: true,
                          onHide: ($event: any) => (filterCallback()),
                          onClearClick: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "expiredDays",
                      header: "Expired Days",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.expiredDays), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "expiryDate",
                      header: "Expiry Date",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.expiryDate.toDateString()), 1)
                      ]),
                      filter: _withCtx(({ filterModel, filterCallback }) => [
                        _createVNode(_component_Calendar, {
                          modelValue: filterModel.value,
                          "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                          selectionMode: "range",
                          manualInput: false,
                          placeholder: "From – To",
                          showButtonBar: true,
                          onHide: ($event: any) => (filterCallback()),
                          onClearClick: ($event: any) => (filterCallback())
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, [
                  (!_ctx.loading)
                    ? {
                        name: "empty",
                        fn: _withCtx(() => [
                          (!_ctx.selectedAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, "Select Account from dropdown to display Licenses."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_20, "The selected license does not have any activations."))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["selection", "rowClass", "value", "rows", "totalRecords", "filters", "loading", "globalFilterFields", "onRowDblclick"])
              ]),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.selectedAccount,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                        options: _ctx.selectableAccounts,
                        optionLabel: "name",
                        optionValue: "id",
                        filter: true,
                        showClear: true,
                        placeholder: "Select a Account",
                        onChange: _ctx.processFilterUpdate
                      }, null, 8, ["modelValue", "options", "onChange"]),
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.mobileSearchTerm,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.mobileSearchTerm) = $event)),
                        placeholder: "Keyword Search"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("div", _hoisted_24, [
                        (_ctx.selectedAccountDto && _ctx.selectedAccountDto.role != 'NewsletterRecipient')
                          ? (_openBlock(), _createBlock(_component_Button, {
                              key: 0,
                              disabled: !_ctx.selectedAccount,
                              label: "Add",
                              class: "p-button-success p-button-outlined",
                              onClick: _ctx.createLicense
                            }, null, 8, ["disabled", "onClick"]))
                          : _createCommentVNode("", true),
                        _createVNode(_component_Button, {
                          label: "Export",
                          class: "p-button-secondary p-button-outlined",
                          onClick: _ctx.exportLicenses
                        }, null, 8, ["onClick"])
                      ])
                    ]),
                    (!_ctx.mobileFilteredItems || _ctx.mobileFilteredItems.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          (!_ctx.selectedAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Select Account from dropdown to display Licenses."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_27, "No licenses found for the current search."))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileFilteredItems, (licenseItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mobile-license-card",
                        key: licenseItem.id
                      }, [
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("h6", null, _toDisplayString(licenseItem.product || '-'), 1),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(licenseItem.type || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                          _hoisted_31,
                          _createTextVNode(" " + _toDisplayString(licenseItem.key || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createTextVNode(" " + _toDisplayString(licenseItem.licenseDomain || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _hoisted_35,
                          _createTextVNode(" " + _toDisplayString(licenseItem.activationsCount) + " / " + _toDisplayString(licenseItem.maximumActivations), 1)
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _hoisted_37,
                          _createTextVNode(" " + _toDisplayString(_ctx.usagePercent(licenseItem)) + "% ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _hoisted_39,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDateValue(licenseItem.createdDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _hoisted_41,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDateValue(licenseItem.expiryDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_42, [
                          _createVNode(_component_Button, {
                            label: "Email",
                            class: "p-button-secondary p-button-outlined",
                            onClick: ($event: any) => {
                _ctx.selectedLicense = licenseItem;
                _ctx.sendLicenseEmail();
              }
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            label: "Copy Key",
                            class: "p-button-secondary p-button-outlined",
                            onClick: ($event: any) => {
                _ctx.selectedLicense = licenseItem;
                _ctx.copyLicenseKey();
              }
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            label: "Copy Hash",
                            class: "p-button-secondary p-button-outlined",
                            onClick: ($event: any) => {
                _ctx.selectedLicense = licenseItem;
                _ctx.copyLicenseHash();
              }
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            label: "Activations",
                            class: "p-button-secondary p-button-outlined",
                            onClick: ($event: any) => {
                _ctx.selectedLicense = licenseItem;
                _ctx.licenseActivationsAction();
              }
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            label: "Edit",
                            class: "p-button-success p-button-outlined",
                            onClick: ($event: any) => (_ctx.modifyLicenseFromGrid(licenseItem))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            label: "Delete",
                            class: "p-button-danger p-button-outlined",
                            onClick: ($event: any) => (_ctx.deleteLicenseFromGrid(licenseItem, $event))
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_Button, {
                            label: "Export",
                            class: "p-button-secondary p-button-outlined",
                            onClick: ($event: any) => (_ctx.exportLicense(licenseItem))
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
              _createVNode(_component_CreateUpdateLicense, {
                license: _ctx.license,
                account: _ctx.selectedAccount,
                onSave: _ctx.processSaveLicense,
                onCancel: _ctx.processCancel
              }, null, 8, ["license", "account", "onSave", "onCancel"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalComponent, { open: _ctx.showEmailModal }, {
          body: _withCtx(() => [
            _createVNode(_component_SendLicenseEmail, {
              account: _ctx.selectedAccountDto,
              license: _ctx.selectedLicense,
              onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showEmailModal = false)),
              onClose: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showEmailModal = false))
            }, null, 8, ["account", "license"])
          ]),
          _: 1
        }, 8, ["open"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_44, [
        (!_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
              _createElementVNode("div", _hoisted_46, [
                _createVNode(_component_DataTable, {
                  class: "license-datatable",
                  dataKey: "id",
                  scrollHeight: "flex",
                  stripedRows: "",
                  selectionMode: "single",
                  selection: _ctx.selectedLicense,
                  "onUpdate:selection": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.selectedLicense) = $event)),
                  stateKey: "license-table-state",
                  removableSort: "",
                  scrollable: true,
                  rowClass: _ctx.rowClass,
                  value: _ctx.items,
                  rows: _ctx.rows,
                  totalRecords: _ctx.totalRecords,
                  filters: _ctx.filters,
                  "onUpdate:filters": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters) = $event)),
                  loading: _ctx.loading,
                  globalFilterFields: _ctx.globalFilter
                }, _createSlots({
                  header: _withCtx(() => [
                    _createElementVNode("div", _hoisted_47, [
                      (_ctx.selectedLicense && _ctx.selectedLicense.id)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                              _createVNode(_component_Button, {
                                disabled: !_ctx.selectedLicense.id,
                                label: "Copy Key",
                                onClick: _ctx.copyLicenseKey,
                                class: "p-button-secondary p-button-outlined"
                              }, null, 8, ["disabled", "onClick"])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  loading: _withCtx(() => [
                    _createTextVNode("Loading licenses. Please wait.")
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      field: "product",
                      header: "Product",
                      style: {"width":"10rem"},
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.product), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "key",
                      header: "Key",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.key), 1)
                      ]),
                      _: 1
                    }),
                    (!_ctx.accountStore.isCustomer)
                      ? (_openBlock(), _createBlock(_component_Column, {
                          key: 0,
                          field: "type",
                          header: "Type",
                          style: {"width":"10rem"},
                          sortable: "",
                          "show-filter-menu": false
                        }, {
                          body: _withCtx(({ data }) => [
                            _createTextVNode(_toDisplayString(data.type), 1)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_Column, {
                      field: "activationsCount",
                      header: "Activations",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.activationsCount), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "maximumActivations",
                      header: "Max",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.maximumActivations), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "usage",
                      header: "Usage",
                      sortable: "",
                      "show-filter-menu": false,
                      style: {"min-width":"8rem"}
                    }, {
                      body: _withCtx(({ data }) => [
                        _createVNode(_component_ProgressBar, {
                          value: (data.activationsCount / data.maximumActivations) * 100,
                          showValue: false
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "licenseDomain",
                      header: "Domain",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.licenseDomain), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "createdDate",
                      header: "Creation Date",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.createdDate.toDateString()), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "expiryDate",
                      header: "Expiry Date",
                      sortable: "",
                      "show-filter-menu": false
                    }, {
                      body: _withCtx(({ data }) => [
                        _createTextVNode(_toDisplayString(data.expiryDate.toDateString()), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 2
                }, [
                  (!_ctx.loading)
                    ? {
                        name: "empty",
                        fn: _withCtx(() => [
                          (!_ctx.selectedAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_50, "Select Account from dropdown to display Licenses."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_51, "The selected license does not have any activations."))
                        ]),
                        key: "0"
                      }
                    : undefined
                ]), 1032, ["selection", "rowClass", "value", "rows", "totalRecords", "filters", "loading", "globalFilterFields"])
              ]),
              (!_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.mobileSearchTerm,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.mobileSearchTerm) = $event)),
                        placeholder: "Keyword Search"
                      }, null, 8, ["modelValue"])
                    ]),
                    (!_ctx.mobileFilteredItems || _ctx.mobileFilteredItems.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                          (!_ctx.selectedAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_55, "Select Account from dropdown to display Licenses."))
                            : (_openBlock(), _createElementBlock("div", _hoisted_56, "No licenses found for the current search."))
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mobileFilteredItems, (licenseItem) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "mobile-license-card",
                        key: licenseItem.id
                      }, [
                        _createElementVNode("div", _hoisted_57, [
                          _createElementVNode("h6", null, _toDisplayString(licenseItem.product || '-'), 1),
                          _createElementVNode("span", _hoisted_58, _toDisplayString(licenseItem.type || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _hoisted_60,
                          _createTextVNode(" " + _toDisplayString(licenseItem.key || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _hoisted_62,
                          _createTextVNode(" " + _toDisplayString(licenseItem.licenseDomain || '-'), 1)
                        ]),
                        _createElementVNode("div", _hoisted_63, [
                          _hoisted_64,
                          _createTextVNode(" " + _toDisplayString(licenseItem.activationsCount) + " / " + _toDisplayString(licenseItem.maximumActivations), 1)
                        ]),
                        _createElementVNode("div", _hoisted_65, [
                          _hoisted_66,
                          _createTextVNode(" " + _toDisplayString(_ctx.usagePercent(licenseItem)) + "% ", 1)
                        ]),
                        _createElementVNode("div", _hoisted_67, [
                          _hoisted_68,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDateValue(licenseItem.createdDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_69, [
                          _hoisted_70,
                          _createTextVNode(" " + _toDisplayString(_ctx.formatDateValue(licenseItem.expiryDate)), 1)
                        ]),
                        _createElementVNode("div", _hoisted_71, [
                          _createVNode(_component_Button, {
                            label: "Copy Key",
                            class: "p-button-secondary p-button-outlined",
                            onClick: ($event: any) => {
                _ctx.selectedLicense = licenseItem;
                _ctx.copyLicenseKey();
              }
                          }, null, 8, ["onClick"])
                        ])
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.loading)
          ? (_openBlock(), _createBlock(_component_ProgressSpinner, { key: 1 }))
          : _createCommentVNode("", true),
        (_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_72, [
              _createVNode(_component_CreateUpdateLicense, {
                license: _ctx.license,
                account: _ctx.selectedAccount,
                onSave: _ctx.processSaveLicense,
                onCancel: _ctx.processCancel
              }, null, 8, ["license", "account", "onSave", "onCancel"])
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_ModalComponent, { open: _ctx.showEmailModal }, {
          body: _withCtx(() => [
            _createVNode(_component_SendLicenseEmail, {
              account: _ctx.selectedAccountDto,
              license: _ctx.selectedLicense,
              onCancel: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showEmailModal = false)),
              onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showEmailModal = false))
            }, null, 8, ["account", "license"])
          ]),
          _: 1
        }, 8, ["open"])
      ]))
}